import { render, staticRenderFns } from "./thWrap.vue?vue&type=template&id=2d493a42&"
import script from "./thWrap.vue?vue&type=script&lang=js&"
export * from "./thWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports